module.exports = __webpack_public_path__ + "img/grok.4799c594.svg";